import { Close } from '@material-ui/icons';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  color: #000000;
  position: absolute;
  right: 20px;
  top: 20px;
  width: 20px;

  > svg {
    float: left;
    width: 25px;
    height: 25px;
  }

  > span {
    vertical-align: middle;
    display: flex;
    float: left;
    font-style: normal;
    font-weight: 500;
    letter-spacing: -0.2px;
  }
`;

function ExitButton(props) {
  return (
    <Wrapper onClick={props.onClick}>
      <Close /> <span>{props.children}</span>
    </Wrapper>
  );
}

export default ExitButton;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/shared/Exit/index.jsx